export const ROLES = {
  ADMIN_SYS: "ADMIN SYS",
  MENTOR: "MENTOR",
  ESTUDIANTE: "ESTUDIANTE",
  ADMIN_ESCOLAR: "ADMIN_ESCOLAR",
};
